export default "__VITE_ASSET__NUqtTySG__"